import React from 'react';
import Modal from '../Modal';
import PropTypes from 'prop-types';

const SuccessModal = ({
  isOpen,
  onClose,
  contentWidth,
  content,
  icon
}) => {

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentWidth={contentWidth}
      detailHeight={'auto'}
      hideHeader={true}>
      <div className='confirmation-icon pb-3 text-center mt-5'>
        <img src={icon} className="img-fluid" />
      </div>
      <div><span className='fw-bold d-flex justify-content-center success-text'>Success</span></div>
      <p className="mb-0 text-center">{content}</p>
      <div className='text-center'>
        <button className="btn btn-castleRed btn-width mt-2"
          onClick={onClose}>
          Ok
        </button>
      </div>
    </Modal>
  );
};

SuccessModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  contentWidth: PropTypes.string,
  content: PropTypes.string,
  icon: PropTypes.string
};

export default SuccessModal;
